import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { isDevelopmentMode } from '@/shared/helpers';
import { authApi } from '@/shared/modules/auth/business';
import { setupListeners } from '@reduxjs/toolkit/query';
import { baseApi } from './baseApi';
import { crossdockBlockedStateReducer } from './modules/crossdockBlocked/business';
import { crossdockReceiptStateReducer } from './modules/crossdockReceipt/business';
import { packingStateReducer } from './modules/packing/business';
import { pickingStateReducer } from './modules/picking/business';
import { placementStateReducer } from './modules/placement/business';
import { printerServiceApi } from './modules/settings/business';
import { stockBlockedStateReducer } from './modules/stockBlocked/business';
import { stockReceiptStateReducer } from './modules/stockReceipt/business';
import { stockStateReducer } from './modules/stocks/business';
import { sharedStateReducer } from './shared.state';
const rootReducer = combineReducers({
    crossdockReceipt: crossdockReceiptStateReducer,
    stockReceipt: stockReceiptStateReducer,
    placement: placementStateReducer,
    packing: packingStateReducer,
    crossdockBlocked: crossdockBlockedStateReducer,
    picking: pickingStateReducer,
    stocks: stockStateReducer,
    stockBlocked: stockBlockedStateReducer,
    shared: sharedStateReducer,
    [authApi.reducerPath]: authApi.reducer,
    [printerServiceApi.reducerPath]: printerServiceApi.reducer,
    [baseApi.reducerPath]: baseApi.reducer,
});
// From https://redux-toolkit.js.org/api/getDefaultMiddleware.
// It is preferable to use the chainable .concat(...) and .prepend(...) methods of the returned Tuple instead of the array spread
// operator, as the latter can lose valuable TS type information under some circumstances.
export const store = configureStore({
    reducer: rootReducer,
    devTools: isDevelopmentMode(),
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(printerServiceApi.middleware, authApi.middleware, baseApi.middleware),
});
setupListeners(store.dispatch);
